import { render } from "./MainTemplate.vue?vue&type=template&id=17918543"
import script from "./MainTemplate.vue?vue&type=script&lang=js"
export * from "./MainTemplate.vue?vue&type=script&lang=js"

import "./MainTemplate.vue?vue&type=style&index=0&id=17918543&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__